
    export default {
        functional: true,
        render(createElement, { props, children, data }) {
            return createElement('div', { class: [ 'gfu-divider-labeled', data.class, data.staticClass ] }, children);
        },
    };
